"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.container = exports.StyledContainer = exports.LoadingHeadline = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("@linaria/react");
const _excluded = ["className", "forwardref", "postComplete"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const LoadingHeadline = exports.LoadingHeadline = /*#__PURE__*/(0, _react.styled)('div')({
  name: "LoadingHeadline",
  class: "l1jejvoz",
  propsAsIs: false
});
const container = exports.container = "cdq0a1g";

// (declare postComplete to keep it out of rest obj)
const Container = _ref => {
  let {
      className,
      forwardref,
      postComplete
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // eslint-disable-line no-unused-vars
    React.createElement("div", _extends({
      ref: forwardref,
      className: `container ${container} ${className}`
    }, rest))
  );
};
Container.propTypes = {
  className: _propTypes.default.string,
  forwardref: _propTypes.default.object,
  postComplete: _propTypes.default.bool
};
const _exp = /*#__PURE__*/() => Container;
const _exp2 = /*#__PURE__*/() => ({
  postComplete
}) => {
  if (postComplete) {
    return 'default';
  }
  return 'wait';
};
const StyledContainer = exports.StyledContainer = /*#__PURE__*/(0, _react.styled)(_exp())({
  name: "StyledContainer",
  class: "scdst81",
  propsAsIs: true,
  vars: {
    "scdst81-0": [_exp2()]
  }
});